import React from "react";
import { Box, Container, Spinner } from "@amzn/awsui-components-react";

export const LoomAgentAssistantLoadingState: React.FC = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "calc(100vh - 200px)",
        padding: "20px",
      }}
    >
      <Spinner size="large" />
      <Box variant="p" padding={{ top: "s" }} color="text-body-secondary">
        Loading Loom Agent Assistant...
      </Box>
    </div>
  );
};
